module.exports = __webpack_public_path__ + "img/116.f510f4aa.jpg";